//热门推荐
<template>
  <div class="hot2">
    <div class="title">
      最新资讯
    </div>
    <div v-for="(item,index) in list" :key="index" class="box1">
      <a class="imgBox" :href="'/Detail?contentId='+item.CONTENT_ID" target="_blank">
        <img :src="item.CONTENT_PHOTO_SMALL" alt="">
      </a>
      <div class="rightlist">
        <a class="titles" :href="'/Detail?contentId='+item.CONTENT_ID" target="_blank">{{ item.CONTENT_TITLE }}</a>
        <span class="times">{{ item.CONTENT_ISSUE_DATE|changeTime }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['list'],
  methods: {
    goDetail: function(contentId) {
      const { href } = this.$router.resolve({
        path: '/Detail',
        name: 'dt',
        query: {
          contentId
        }
      })
      window.open(href, '_blank')
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .hot2{
        background-color: #fff;
        padding-bottom: 20px;
        overflow: hidden;
        padding-top: 10px;
        margin-top: 10px;
        .title{
            height: 20px;
            line-height: 20px;
            border-left: 2px solid #ed4040;
            padding-left: 10px;
            font-size: 16px;
            margin-left: 20px;
            margin-bottom: 10px;
        }
        .box1{
            padding: 10px 20px;
            .imgBox{
                width: 96px;
                height: 64px;
                display: inline-block;
                img{
                    width: 96px;
                    height: 64px;
                    cursor: pointer;
                }
            }
            .rightlist{
                display: inline-block;
                width: 150px;
                height: 64px;
               margin-left: 10px;
                vertical-align: top;
                .titles{
                  cursor: pointer;
                    display: inline-block;
                    width: 100%;
                    height: 34px;
                    font-size: 12px;
                    margin-bottom: 10px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp:2;
                    -webkit-box-orient: vertical;
                  &:hover{
                    color: #ed4040;
                  }

                }
                .times{
                    color: #b2b2b2;
                    font-size: 12px;
                }
            }

        }
    }
</style>
